import { Link } from "@/lib/router-compat";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Clock } from "lucide-react";
import type { Article } from "@/data/articles";

const ArticleCard = ({ slug, title, excerpt, date, readTime }: Article) => {
  const formattedDate = new Date(date + "T12:00:00").toLocaleDateString("es-ES", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <Link to={`/articulos/${slug}`} className="block group">
      <Card className="h-full transition-shadow hover:shadow-lg">
        <CardHeader>
          <CardTitle className="text-xl group-hover:text-primary transition-colors line-clamp-2">
            {title}
          </CardTitle>
          <CardDescription className="flex items-center gap-3 text-xs">
            <span>{formattedDate}</span>
            <span className="flex items-center gap-1">
              <Clock className="h-3 w-3" /> {readTime}
            </span>
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground text-sm">{excerpt}</p>
        </CardContent>
      </Card>
    </Link>
  );
};

export default ArticleCard;
